import axios from './client';

export function plan(params) {
  return axios.get('/plan/', { params });
}

export function create(data) {
  return axios.post('/plan/', data);
}

export async function update(data) {
  return axios.put(`/plan/${data.id}/`, data);
}

export function remove(data) {
  return axios.delete(`/plan/${data.id}/`);
}
